import { render, staticRenderFns } from "./OrderCounter.vue?vue&type=template&id=ff78d878&scoped=true&"
import script from "./OrderCounter.vue?vue&type=script&lang=js&"
export * from "./OrderCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff78d878",
  null
  
)

export default component.exports